/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-24",
    versionChannel: "nightly",
    buildDate: "2025-04-24T00:06:44.293Z",
    commitHash: "67c0795297aa61e9665b78c0998a3149005c848b",
};
